import { Button, Typography, Hidden } from '@mui/material';

import Grid from 'components/core/Grid';
import {
  headerVacationRentalListingImage,
  headerVacationRentalSearchImage,
  headerVacationRentalsImage,
  listMobileHeaderVacationImage,
} from 'config/imageUrls';
import { ContentSection, AnimatedImageWrapper, AnimatedImage1, AnimatedImage2, AnimatedImage3 } from './styles';
import { useListPageModalNavigation } from '../modal/hooks/useListPageModalNavigation';

export const HeroHeader = ({ openModal, openHelpModal }: { openModal: () => void; openHelpModal: () => void }) => {
  const { pushUnassistedUrl } = useListPageModalNavigation();

  const handleClick = () => {
    pushUnassistedUrl();
    openModal();
  };

  return (
    <>
      <ContentSection>
        <Grid container spacing={4}>
          <Grid item xs={12} md={5}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="h1" color={'primary'}>
                  More guests for your mountain vacation rental property
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>
                  alluraDirect provides marketing and management tools for vacation rental properties at ski resort
                  destinations. <br />
                  <br />
                  Effortlessly coordinate reservations each step of the way; from the initial inquiry, to the confirmed
                  online payment, to receiving a stellar review after your guest departs.
                  <br />
                  <br />
                  Signing up is free, fast, and easy.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Button variant="contained" color="secondary" size="large" fullWidth onClick={handleClick}>
                  Get Started
                </Button>

                <Button variant="text" color="secondary" size="large" fullWidth onClick={openHelpModal}>
                  Contact Sales
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <AnimatedImageWrapper item xs={12} md={7} sx={{ display: { xs: 'none', sm: 'block' } }}>
            <AnimatedImage1>
              <img src={headerVacationRentalsImage} />
            </AnimatedImage1>
            <AnimatedImage2>
              <img src={headerVacationRentalSearchImage} />
            </AnimatedImage2>
            <AnimatedImage3>
              <img src={headerVacationRentalListingImage} />
            </AnimatedImage3>
          </AnimatedImageWrapper>
          <Hidden smUp>
            <img src={listMobileHeaderVacationImage} style={{ width: '100%' }} />
          </Hidden>
        </Grid>
      </ContentSection>
    </>
  );
};
